import React, { useEffect } from "react";

import "./jobListingSearchResultCards.scss";


export default function JobListingSearchResultCards({openJd}) {

  useEffect(() => {
  }, []);


  return (
      <div className="job-card">
                  <div className="job-card-title">
                     <div className = "title-heading">
                        [{openJd?.QhCompanyJID}] {openJd?.JDDetails.Title}
                     </div>
                     <div className = "title-postedDate">
                        1 day ago
                     </div>                                             
                  </div>
                  <div className="job-card-details">
                     <div className="job-card-details-size-sub-heading">
                       Details:
                     </div>
                     <div className="job-card-details-size">
                       {openJd.JDRequired?.MinExperience} to {openJd.JDRequired.MaxExperience} Yrs
                     </div>
                     <div className="job-card-details-size">
                       {openJd?.JDDetails.JobTime}
                     </div>
                     <div className="job-card-details-size">
                       {openJd?.JDDetails.JobType}
                     </div>                     
                     <div className="job-card-details-size">
                        {openJd.JDRequired?.WorkLocation}
                     </div>
                     <div className="job-card-details-size">
                       Max {openJd.JDRequired?.NoticePeriod} days
                     </div>  
                     <div className="job-card-details-size">
                       {openJd.JDProject.MinCtc} to {openJd?.JDProject.MaxCtc} LPA
                     </div>                     
                     <div className="job-card-details-size-no-border">
                       {openJd.JDRequired?.WorkMode}
                     </div>                                                                                                                            
                  </div>
                  <div className="job-card-details">
                     <div className="job-card-details-size-sub-heading">
                       Main Skills:
                     </div>
                     <div className="job-card-details-keywords">
                       {openJd.JDRequired.Keywords}
                     </div>                                                                                                                           
                  </div> 
                  <div className="job-card-details">
                     <div className="job-card-details-size-sub-heading">
                       Education:
                     </div>
                     <div className="job-card-details-keywords">
                       {openJd?.JDRequired.Education}
                     </div>                                                                                                                           
                  </div> 
                  <div className="job-card-details">
                     <div className="job-card-details-size-sub-heading">
                       Posted By:
                     </div>
                     <div className="job-card-details-size">
                     {(openJd?.AccountType=="StaffingOrg")
                          &&(openJd?.JDProject.ReqType == "customer_project")
                          &&(openJd?.JDClient.ClientJobType=="FTE")?
                          "Recruitment Agency":"HR"}
                     </div>                     
                     <div className="job-card-details-keywords">
                       {openJd?.Organization}
                     </div>                                                                                                                           
                  </div>                   
                                                                        
      </div>                  
  );
}
